<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div class="form-edit-page">
        <div class="row-start row-space">
            
            <div class="form-item-char30">
                <label class="label-caption">Tipo</label>
                <select v-model="opcaoSelecionada">
                    <option v-for="opcao in lsOpcoes" :key="opcao.id" :value="opcao.id">{{ opcao.descricao }}</option>
                </select>
            </div>
        </div>


        <div v-show="opcaoSelecionadaObj.ckNumeros" class="row-start row-space">
            <div class="form-item-char20">
                <label class="label-caption">Número Inicial</label>
                <input type="text" class="input-right" v-model="edNroInicial" v-number maxlength="11" />
            </div>
            <div class="form-item-char20">
                <label class="label-caption">Número Fincal</label>
                <input type="text" class="input-right" v-model="edNroFinal" v-number maxlength="11" />
            </div>
        </div>


        <div v-show="opcaoSelecionadaObj.ckPeriodo" class="row row-space">
            <div class="form-item-rangedata"><DateRangeSelect v-model="dateRange" /></div>
        </div>


        <div class="row-start">
            <button type="button" @click="openReport">Imprimir</button>
            <button type="button" @click="closeForm">Retornar</button>

        </div>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import { Validacoes } from '@/funcoes/validacoes';
import DateRangeSelect from '@/components/DateRangeSelect.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close']);
const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const edNroInicial = ref(null);
const edNroFinal = ref(null);
const msgAlerta = ref(null);
const isLoading = ref(false);
let informacoes;

const lsOpcoes = ref([
    {id: 'cupons_numeros', descricao: 'Listagem por Numeração', ckPeriodo: false, ckNumeros: true},
    {id: 'cupons_periodo', descricao: 'Listagem por Emissão',   ckPeriodo: true,  ckNumeros: false},
]);
const opcaoSelecionada = ref('cupons_numeros');
const opcaoSelecionadaObj = computed(() =>
    lsOpcoes.value.find(o => o.id === opcaoSelecionada.value) || {}
);

function closeForm() {emit('close')}

async function openReport() {
    try{
        if (opcaoSelecionadaObj.value.ckPeriodo) Validacoes.validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        msgAlerta.value = null;
        isLoading.value = true;
        if (opcaoSelecionadaObj.value.ckPeriodo){
            informacoes = `Período: ${Funcoes.formatDateFromJson(dateRange.value.startDate)} a ${Funcoes.formatDateFromJson(dateRange.value.endDate)}`;
        }else{informacoes = null}
        const dados = {
            nmrelatorio: opcaoSelecionada.value,
            idmunicipio: globalStore.idmunicipio,
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate,
            intp1: Funcoes.integerFromString(edNroInicial.value),
            intp2: Funcoes.integerFromString(edNroFinal.value),
            informacoes: informacoes,
            idlogin: globalStore.idlogin,
            idusuario: globalStore.idusuario};
        const response = await Api.genericReport(dados);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}
</script>